<!-- TODO - fix this markup so it works on mobile and desktop without need for duplication -->

<!-- this table is for display on desktop; mobile version below -->
<div class="autopay-box d-none d-md-block">
    <form>
        <table class="table">
            <thead>
            <tr>
                <th>Enable Auto-pay?</th>
                <th>Organization</th>
                <th>Payment Method</th>
                <th>Payment Limit</th>
            </tr>
            </thead>
            <tbody>
            <!--suppress HtmlUnknownAttribute -->
            <ng-template *ngIf="!isLoading && memberships && memberships.length" [ngForOf]="memberships" let-m="index"
                         let-membership ngFor>
                <tr>
                    <td class="autopay pt-0" data-label="Enable Auto-pay?">
                        <label aria-label="toggle autopay" [attr.data-org-id]="membership.organizationId" class="switch">
                            <input #autopayEnabledCheck (ngModelChange)="autopayChanged(m, autopayEnabledCheck.checked);"
                                   [ngModelOptions]="{standalone: true}"
                                   [ngModel]="membership.profile.autopayEnabled"
                                   type="checkbox"/>
                            <span></span>
                        </label>
                    </td>
                    <td data-label="Organization">{{membership.organization.name}}</td>
                    <td data-label="Payment Method">
                        <div
                            *ngIf="membership.profile.autopayEnabled && membership.profile.paymentMethod && membership.profile.paymentMethodType">
                            <div *ngIf="membership.profile.paymentMethodType.indexOf('CreditCard') !== -1">
                                Card: xxxx-xxxx-xxxx-{{membership.profile.paymentMethod.last4}}
                            </div>
                            <div *ngIf="membership.profile.paymentMethodType.indexOf('BankAccount') !== -1">
                                Bank: <span [innerHTML]="membership.profile.paymentMethod.friendlyName"></span>
                            </div>
                            <div class="late-fee">
                                <span>
                                Next autopay check: {{null | legfiDate:'MM/DD/YYYY'}}
                                    <lf-countdown (zeroReached)="determineNextAutopayTime()" [end]="nextAutopay"
                                                  [units]="'Hours | Minutes'"></lf-countdown>
                                    </span>
                            </div>
                        </div>
                        <div
                            *ngIf="!membership.profile.autopayEnabled || !membership.profile.paymentMethod || !membership.profile.paymentMethodType">
                            N/A
                        </div>
                    </td>
                    <td data-label="Payment Limit">
                        <span *ngIf="membership.profile.autopayEnabled && membership.profile.autopayMax"
                              [innerHTML]="membership.profile.autopayMax | legfiCurrency:'USD':'symbol':'.2'"></span>
                        <span *ngIf="!membership.profile.autopayEnabled || !membership.profile.autopayMax">N/A</span>
                        <div *ngIf="membership.profile.autopayEnabled && membership.profile.autopayMax"
                             class="late-fee">
                            <span>
                                {{(membership.profile.autopayMax - membership.autopaidChargeSum) |
                                legfiCurrency:'USD':'symbol':'.2'}} / {{membership.profile.autopayMax |
                                legfiCurrency:'USD':'symbol':'.2'}} remaining.
                                Resets on the 1st.
                            </span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <tr *ngIf="!isLoading && !(memberships && memberships.length)">
                <td colspan="4">
                    You are not a member of any organizations, so there are no settings to configure.
                </td>
            </tr>
            <tr *ngIf="isLoading">
                <td colspan="4">
                    Loading ...
                </td>
            </tr>
            </tbody>
        </table>
    </form>
</div>


<!-- this repeated card version is for mobile -->
<div class="d-md-none d-sm-block mobile">
    <form>
        <div *ngIf="!isLoading && !(memberships && memberships.length)" class="card">
            <div class="card-body">
                You are not a member of any organizations, so there are no settings to configure.
            </div>
        </div>
        <div *ngIf="isLoading" class="card">
            <div class="card-body">
                Loading ...
            </div>
        </div>

        <!--suppress HtmlUnknownAttribute -->
        <ng-template *ngIf="!isLoading && memberships && memberships.length" [ngForOf]="memberships" let-m="index"
                     let-membership ngFor>
            <div class="card mx-2">
                <div class="card-body">
                    <div class="autopay mb-2">
                        <label class="switch">
                            <input #autopayEnabledCheck (ngModelChange)="autopayChanged(m, autopayEnabledCheck.checked);"
                                   [ngModelOptions]="{standalone: true}"
                                   [ngModel]="membership.profile.autopayEnabled"
                                   type="checkbox"/>
                            <span></span>
                            Enable Auto-pay?
                        </label>
                    </div>

                    <div class="mb-2">Organization: <strong>{{membership.organization.name}}</strong></div>

                    <div class="mb-2">Payment method:
                        <div class="font-weight-bold d-inline-block">
                            <div *ngIf="membership.profile.autopayEnabled && membership.profile.paymentMethod && membership.profile.paymentMethodType">
                                <div *ngIf="membership.profile.paymentMethodType.indexOf('CreditCard') !== -1">
                                    Card: xxxx-xxxx-xxxx-{{membership.profile.paymentMethod.last4}}
                                </div>
                                <div *ngIf="membership.profile.paymentMethodType.indexOf('BankAccount') !== -1">
                                    Bank: <span [innerHTML]="membership.profile.paymentMethod.friendlyName"></span>
                                </div>
                                <div class="late-fee">
                                <span>
                                Next autopay check: {{null | legfiDate:'MM/DD/YYYY'}}
                                    <lf-countdown (zeroReached)="determineNextAutopayTime()" [end]="nextAutopay"
                                                  [units]="'Hours | Minutes'"></lf-countdown>
                                    </span>
                                </div>
                            </div>
                            <div *ngIf="!membership.profile.autopayEnabled || !membership.profile.paymentMethod || !membership.profile.paymentMethodType"
                                 class=" d-inline-block">
                                N/A
                            </div>
                        </div>
                    </div>

                    <div>Payment Limit:
                        <div class="font-weight-bold d-inline-block">
                        <span *ngIf="membership.profile.autopayEnabled && membership.profile.autopayMax"
                              [innerHTML]="membership.profile.autopayMax | legfiCurrency:'USD':'symbol':'.2'"></span>
                            <span *ngIf="!membership.profile.autopayEnabled || !membership.profile.autopayMax">N/A</span>
                            <div *ngIf="membership.profile.autopayEnabled && membership.profile.autopayMax"
                                 class="late-fee">
                                <span>
                                    {{(membership.profile.autopayMax - membership.autopaidChargeSum) |
                                    legfiCurrency:'USD':'symbol':'.2'}} / {{membership.profile.autopayMax |
                                    legfiCurrency:'USD':'symbol':'.2'}} remaining.
                                    Resets on the 1st.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </form>
</div>
